interface SiteStagingJSON {
  staging: StagingStatus;
}

export interface GetSiteStagingResponseJSON {
  data: SiteStagingJSON;
}

// Staging
export type StagingStatus = 'on' | 'off' | 'creating' | 'publishing' | 'finished';

export class SiteStaging {
  static CREATING = 'creating';
  static PUBLISHING = 'publishing';
  static ON = 'on';

  public constructor(public staging: StagingStatus) {}

  // Constructs an object from a JSON-encoded staging lookup result
  public static fromJSON(siteStagingJSON: SiteStagingJSON): SiteStaging {
    return new SiteStaging(siteStagingJSON.staging);
  }
}

// PushToLive
export class PushLiveOptions {
  public constructor(public siteComponents: string, public preserveStaging: boolean) {}
}
